import {
  OreButton,
  OreHeading,
  OreModal,
  OreModalBox,
  OreModalBoxBody,
  OreModalBoxFooter,
  OreText,
} from '@edenredespana/oreneta'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export type CancelPopupActions = {
  open: () => void
}

export const CancelPopup = forwardRef<CancelPopupActions>((_, ref): JSX.Element => {
  const { t } = useTranslation()
  const [open, setOpen] = useState<boolean>(false)

  const { navigateToOrigin } = useBankAccount()

  useImperativeHandle(ref, () => ({
    open: async (): Promise<void> => {
      setOpen(true)
    },
  }))

  const saveAndClose = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ): Promise<void> => {
    event?.preventDefault()
    navigateToOrigin()
  }

  return (
    <OreModal open={open} handleOnClose={() => setOpen(false)}>
      <OreModalBox size="medium" handleOnClose={() => setOpen(false)}>
        <OreModalBoxBody>
          <OreHeading size="headline-lg">
            {t(contractTranslation.changeBankAccount.modal.title)}
          </OreHeading>
          <OreText>{t(contractTranslation.changeBankAccount.modal.description)}</OreText>
        </OreModalBoxBody>
        <OreModalBoxFooter>
          <OreButton onClick={() => setOpen(false)} size="small" category="secondary">
            {t(formTranslation.common.buttons.cancel)}
          </OreButton>
          <OreButton onClick={saveAndClose} size="small" category="primary">
            {t(formTranslation.common.buttons.confirm)}
          </OreButton>
        </OreModalBoxFooter>
      </OreModalBox>
    </OreModal>
  )
})
